import { render, staticRenderFns } from "./ContractUpdatePage.vue?vue&type=template&id=b9fb0af2&scoped=true"
import script from "./ContractUpdatePage.vue?vue&type=script&lang=js"
export * from "./ContractUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./ContractUpdatePage.vue?vue&type=style&index=0&id=b9fb0af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fb0af2",
  null
  
)

export default component.exports